<template>
<car-loading v-if="car.general.length == 0" ></car-loading>
<div class="car-detail" v-else="">
	<v-rss :car="car"></v-rss>
	<v-auction-detail :car="car"></v-auction-detail>
	<div  class="">
		<b-container id="specifications" fluid>
			<b-row>
				<b-col class="p-0" md="12" xl="8" lg="7">
					<font-awesome-layers class="fa-3x favourite-car-slide" v-if="is_favourite" @click="remove_favorite()">
						<font-awesome-icon :icon="['fas', 'heart']" />
						<font-awesome-icon :icon="['fal', 'heart']" />
					</font-awesome-layers>
						<font-awesome-layers class="fa-3x non favourite-car-slide" v-else @click="add_favorite()">
						<font-awesome-icon :icon="['fas', 'heart']" :style="{ color: 'white' }" />
						<font-awesome-icon :icon="['fal', 'heart']" />
					</font-awesome-layers>
					<b-carousel id="car-slide" class="car-slide" indicators controls :interval="0">
						<b-carousel-slide v-for="(image, index) in car.photos" :key="index" v-bind:style=" { background: 'url('+car.photos[0].url_image+')', backgroundSize: 'cover', backgroundPosition: 'center' }">
							<template v-slot:img>
								<zoom-on-hover :img-normal="image.url_image" :img-zoom="image.url_image" :scale="2"></zoom-on-hover>
							</template>
						</b-carousel-slide>
					</b-carousel>
					<b-link class="link-liq" v-if="is_liquidation" :href="car.competitive_settlement" target="_blank">
						<div class="text-center bg-macal text-white big-liquidation-banner" >LIQUIDACIÓN CONCURSAL</div>
					</b-link>
					<b-row no-gutters class="d-lg-none">
						<b-col class="mt-2 text-right">
							<social-sharing :url="favourite_url"
							:title="car.car_brand+' '+car.model_nsr+' '+car.version_nsr+' con precio mínimo: $'+parsedPrice+' en macal.cl'"
							:description="car.car_brand+' '+car.model_nsr+' '+car.version_nsr+' con precio mínimo: $'+parsedPrice+' en macal.cl'"
							:quote="car.car_brand+' '+car.model_nsr+' '+car.version_nsr+' con precio mínimo: $'+parsedPrice+' en macal.cl'"
							hashtags="macal"
							twitter-user=""
							inline-template>
								<span>
									<network network="facebook">
										<font-awesome-layers class="fa-3x" @click="social_counter(1)">
											<font-awesome-icon :icon="['fas', 'circle']" class="text-primary" />
											<font-awesome-icon :icon="['fab', 'facebook-f']" transform="shrink-6" class="text-white" />
										</font-awesome-layers>
									</network>
									<network network="twitter">
										<font-awesome-layers class="fa-3x">
											<font-awesome-icon :icon="['fas', 'circle']" class="text-info" />
											<font-awesome-icon :icon="['fab', 'twitter']" transform="shrink-6" class="text-white" />
										</font-awesome-layers>
									</network>
									<network network="whatsapp">
										<font-awesome-layers class="fa-3x">
											<font-awesome-icon :icon="['fas', 'circle']" class="text-success" />
											<font-awesome-icon :icon="['fab', 'whatsapp']" transform="shrink-6" class="text-white" />
										</font-awesome-layers>
									</network>
									<network network="email">
										<font-awesome-layers class="fa-3x">
											<font-awesome-icon :icon="['fas', 'circle']" class="text-warning" />
											<font-awesome-icon :icon="['fal', 'envelope']" transform="shrink-6" class="text-white" />
										</font-awesome-layers>
									</network>
								</span>
							</social-sharing>
							<font-awesome-layers class="fa-3x" @click="copy()">
								<font-awesome-icon :icon="['fas', 'circle']" class="text-danger" />
								<font-awesome-icon :icon="['fal', 'copy']" transform="shrink-6" class="text-white" />
							</font-awesome-layers>
						</b-col>
					</b-row>
				</b-col>
				<b-col>
					<b-row class="mt-1">
						<b-col v-if="car.inspection_grade" class="ml-3">
								<b-table-simple borderless class="m-0">
									<b-tr>
										<b-td class="p-0 text-left">
											<span id="tooltip-grade" @mouseover="onOpen()" @mouseleave="onClose()" class="h3 text-macal border-radius">
												<b>{{car.inspection_grade.replace(".",",")}}<small><b>/7</b></small></b>
											</span>
											<div class="h6 text-macal">Nota Macal</div>
										</b-td>
										<b-td class="p-1 pt-2 text-right">
											<b class="px-5" style="border-bottom: 5px solid #F7F7F7;" v-if="car.lote_status">Lote {{car.lote}}</b>
										</b-td>
									</b-tr>
								</b-table-simple>
								<b-tooltip target="tooltip-grade" v-if="car.grade_detail && car.grade_detail !== null" ref="tooltip" triggers="hover" placement="bottomright">
									<b-table-simple borderless small>
										<b-tr>
											<b-td class="text-left text-white" colspan="2">
												<b>Accesorios y Equipamiento</b>
											</b-td>
										</b-tr>
										<b-tr>
											<b-td class="w-100">
												<b-progress :value="parseFloat(car.grade_detail.equipment)" :max="7.0"></b-progress>
											</b-td>
											<b-td class="text-left text-white" style="width: 1%">
												{{new Intl.NumberFormat("es-CL").format(car.grade_detail.equipment)}}
											</b-td>
										</b-tr>
										<b-tr>
											<b-td class="text-left text-white" colspan="2">
												<b>Mecánica</b>
											</b-td>
										</b-tr>
										<b-tr>
											<b-td class="w-100">
												<b-progress :value="parseFloat(car.grade_detail.motor)" :max="7"></b-progress>
											</b-td>
											<b-td class="text-left text-white" style="width: 1%">
												{{new Intl.NumberFormat("es-CL").format(car.grade_detail.motor)}}
											</b-td>
										</b-tr>
										<b-tr>
											<b-td class="text-left text-white" colspan="2">
												<b>Estética</b>
											</b-td>
										</b-tr>
										<b-tr>
											<b-td class="w-100">
												<b-progress :value="parseFloat(car.grade_detail.bodywork)" :max="7"></b-progress>
											</b-td>
											<b-td class="text-left text-white" style="width: 1%">
												{{new Intl.NumberFormat("es-CL").format(car.grade_detail.bodywork)}}
											</b-td>
										</b-tr>
									</b-table-simple>
								</b-tooltip>
						</b-col>
						<b-col v-else class="ml-3">
							<h4>
								<b-table-simple id="tooltip-target-1"  borderless>
									<b-tr>
										<b-td width="1%" class="p-0 text-left">
											<b id="tooltip-grade" class="text-macal">EN EVALUACIÓN</b><br><small class="text-macal">NOTA MACAL</small>
										</b-td>
										<b-td>
											<b class="bg-grey p-2 px-4 border-radius" v-if="car.lote_status" ><small><b>Lote {{car.lote}}</b></small></b>
										</b-td>
									</b-tr>
								</b-table-simple>
							</h4>
						</b-col>
					</b-row>
					<div class="m-0 mt-2 pt-1 ml-3">
						<b-row>
							<b-col>
								<div class="m-0 p-0 text-grey" style="font-weight: 500; font-size: 1.1rem;">{{car.car_brand}}</div>
								<div class="m-0 p-0" style="font-size: 1.9rem; line-height: 1.4rem; font-weight: 500;">{{car.model_nsr}} {{car.version_nsr}}</div>
							</b-col>
						</b-row>
					</div>
					<b-row>
						<b-table-simple id="tooltip-target-1"  borderless style="font-size: 1rem; text-decoration: underline;" class="m-0 mt-4 ml-3">
							<b-tr>
								<b-td v-if="car.cav_url">
									<b-link :href="car.cav_url" target="_blank">CAV</b-link>
								</b-td>
								<b-td v-if="car.inspection_grade && car.grade_detail !== null">
									<b-link :href="inspection_url" target="_blank">Inspección General</b-link>
								</b-td>
								<b-td v-if="car.visual_grade">
									<b-link :href="visual_inspection_url">Inspección Visual</b-link>
								</b-td>
							</b-tr>
						</b-table-simple>
					</b-row>
					<b-row>
						<b-col class="p-1 pl-3">
							<b-table-simple borderless class="text-dark bg-grey mb-2" >
								<b-tr>
									<b-td style="line-height: 1em;" width="33%"><small>Año</small><br /><b>{{car.year}}</b></b-td>
									<b-td style="line-height: 1em;" width="33%"><small>Tracción</small><br /><b>{{car.car_traction}}</b></b-td>
									<b-td style="line-height: 1em;" width="33%"><small>Km</small><br /><b>{{car.kilometers | numberFormat}}</b></b-td>
								</b-tr>
							</b-table-simple>
							<b-table-simple borderless class="text-dark bg-grey" >
								<b-tr>
									<b-td style="line-height: 1em;" width="33%"><small>Combustible</small><br /><b>{{car.car_fuel_type}}</b></b-td>
									<b-td style="line-height: 1em;" width="33%"><small>Cilindrada</small><br /><b>{{car.engine_size}}</b></b-td>
									<b-td style="line-height: 1em;" width="33%"><small>Transmisión</small><br /><b>{{car.car_transmission}}</b></b-td>
								</b-tr>
							</b-table-simple>
						</b-col>
					</b-row>	
					<b-row class="mt-2 mb-2 pl-3">
						<b-col class="p-1" md="12" lg="8">
							<span class="text-macal">
								<span style="font-size: .9em">Precio mínimo </span><br />
								<span v-if="car.price != null" class="price">
									<b v-if="car.price != 0"><span style="font-size: 50%;">$</span>{{car.price | numberFormat}}</b><b v-else><span style="font-size: 50%;">$</span>0</b>
								</span>
								<span v-else class="price">
									<b><span style="font-size: 50%;"></span>Próximamente</b>
								</span>
							</span>
						</b-col>
						<b-col class="p-1 mt-1 pt-4" md="12" lg="4">
							<b-button variant="macal" size="sm" block :href="'https://www.macal.cl/Carro/AbonoNuevaWebOnline?autocavid='+car.operational_id"><b>INSCRÍBETE</b></b-button>
						</b-col>
					</b-row>
					<b-row class="pl-3 text-center">
						<b-col class="px-1">
							<div style="font-size: .7em;"> ¿No es el que buscas?</div>
							<div><b-link href="https://www.macal.cl/MiSitio/Vehiculos/EncargaCompra" style="text-decoration: underline"><b>ENCÁRGALO</b></b-link></div>
						</b-col>
						<b-col class="px-1">
							<div style="font-size: .7em;"> Dejalo en parte de pago</div>
							<div><b-link :to="{ name: 'vehicles-sell'}" style="text-decoration: underline"><b>VENDE HOY</b></b-link></div>
						</b-col>
						<b-col class="px-1">
							<div style="font-size: .7em;"> ¿Financiamiento?</div>
							<div><b-link :to="{ name: 'vehicles-financing', params: {simulation: this.simulation }}" style="text-decoration: underline"><b>MI CRÉDITO</b></b-link></div>	
						</b-col>
					</b-row>
					<!--
					<div v-if="simulation.loading">
						<vue-content-loading :speed="2" :width="400" :height="30">
							<rect x="5" y="0" rx="0" ry="0" width="180" height="30" />
						</vue-content-loading>
					</div>
					<div v-else="">
						{{due}} cuotas de
						<h2><b>$ {{simulation.amount | numberFormat }}</b> <small><router-link :to="{ name: 'vehicles-financing', params: {simulation: this.simulation } }">ver</router-link></small></h2>
					</div>
					<b-row>
						<b-col class="py-1" cols="6" v-if="car.auction.general_base_pdf_url">
							<b-link :href="car.auction.general_base_pdf_url" target="_blank"><font-awesome-icon :icon="['fal', 'download']" /> Bases</b-link>
						</b-col>
						<b-col class="py-1" cols="6" v-if="car.auction.process_pdf_url">
							<b-link :href="car.auction.process_pdf_url" target="_blank"><font-awesome-icon :icon="['fal', 'download']" /> Procedimiento</b-link>
						</b-col>
					</b-row>
					-->
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<v-section-white class="mt-5 d-none d-lg-block" >
				<h2 v-if="car.inspection_grade && car.grade_detail !== null" class="text-center">Inspección General</h2>
				<b-col class="mt-5">
					<b-row>
						<b-col>
							<b-tabs v-if="car.inspection_grade && car.grade_detail !== null" content-class="mt-3" class="macal-tabs specifications-tab car-general-tabs" vertical nav-wrapper-class="col-md-3">
								<b-tab v-if="false">
									<template v-slot:title></template>
									<b-row>
										<b-col>
											<h2 class="text-center"><b>¡Participa Informado!</b></h2>
											<h3 class="my-4 text-center"> +85 puntos de revisión validados por <b-img src="images/detail/logo-fullmec.png" class="d-inline-block" height="70px" ></b-img></h3>
											<h3 class="text-center"> Conoce la  de este auto</h3>
											<div class="h2 my-5 text-center">
												<div class="bg-macal d-inline-block text-white p-2 py-4 border-radius"><b>{{car.inspection_grade.replace(".",",")}} puntos</b></div>
											</div>
										</b-col>
									</b-row>
								</b-tab>
								<b-tab active>
									<template v-slot:title>
										<b-table-simple class="h3 text-left" small borderless>
											<b-tr>
												<b-td width="1%" class="text-middle ">
													<font-awesome-icon :icon="['fal', 'key']" />
												</b-td>
												<b-td class="pl-3 text-middle text-left">
													Accesorios y Equipamiento
												</b-td>
											</b-tr>
										</b-table-simple>
									</template>
									<b-table-simple fixed borderless class="text-center">
										<b-tr class="text-center">
											<b-td><b class="bg-macal text-white p-2 border-radius">Confort</b></b-td>
											<b-td><b class="bg-macal text-white p-2 border-radius">Exterior</b></b-td>
											<b-td><b class="bg-macal text-white p-2 border-radius">Multimedia</b></b-td>
											<b-td><b class="bg-macal text-white p-2 border-radius">Seguridad</b></b-td>
										</b-tr>
										<b-tr>
											<b-td>
												<ul class="text-left macal-ul" v-for="(element, key) in equipment.confort" :key="key">
													<li>{{element.title}}</li>
												</ul>
											</b-td>
											<b-td>
												<ul class="text-left macal-ul" v-for="(element, key) in equipment.exterior" :key="key">
													<li>{{element.title}}</li>
												</ul>
											</b-td>
											<b-td>
												<ul class="text-left macal-ul" v-for="(element, key) in equipment.multimedia" :key="key">
													<li>{{element.title}}</li>
												</ul>
											</b-td>
											<b-td>
												<ul class="text-left macal-ul" v-for="(element, key) in equipment.security" :key="key">
													<li>{{element.title}}</li>
												</ul>
											</b-td>
										</b-tr>
									</b-table-simple>
								</b-tab>
								<b-tab>
									<template v-slot:title>
										<b-table-simple class="h3 text-left" small borderless>
											<b-tr>
												<b-td width="1%" class="text-middle ">
													<font-awesome-icon :icon="['fal', 'clipboard-list-check']" />
												</b-td>
												<b-td class="pl-3 text-middle text-left">
													Estado del Auto
												</b-td>
											</b-tr>
										</b-table-simple>
									</template>
									<b-tabs class="macal-tabs car-general-tabs">
										<b-tab>
											<template v-slot:title>
												Estética
											</template>
											<b-alert show variant="faded" class="my-4 bg-grey">
												<b-table-simple borderless small>
													<b-tr>
														<b-th><small><b>Leyenda:</b></small></b-th>
														<b-td>
															<font-awesome-icon :icon="['fas', 'check-circle']" size="lg" class="text-success mr-2" />
															<small>Auto no presenta fallas en pieza.</small>
														</b-td>
														<b-td>
															<font-awesome-icon :icon="['fas', 'exclamation-circle']" size="lg" class="text-warning mr-2" />
															<small>Auto presenta fallas leves, medias o graves en pieza.</small>
														</b-td>
													</b-tr>
												</b-table-simple>
											</b-alert>
											<b-table-simple borderless>
												<b-tr>
													<b-td></b-td>
													<b-td class="text-center">Rayas/Piquetes</b-td>
													<b-td class="text-center">Abollón/Daño</b-td>
												</b-tr>
												<b-tr v-for="(element, key) in bodywork.scratch" :key="key">
													<b-td>{{element.title}}</b-td>
													<b-td class="text-center" v-b-tooltip.hover :title="element.tooltip">
														<font-awesome-icon :icon="['fas', 'check-circle']" size="lg" class="text-success mr-2" v-if="element.value" />
														<font-awesome-icon :icon="['fas', 'exclamation-circle']" size="lg" class="text-warning mr-2" v-else />
													</b-td>
													<b-td class="text-center" v-b-tooltip.hover :title="bodywork.dent[key].tooltip">
														<font-awesome-icon :icon="['fas', 'check-circle']" size="lg" class="text-success mr-2" v-if="bodywork.dent[key].value" />
														<font-awesome-icon :icon="['fas', 'exclamation-circle']" size="lg" class="text-warning mr-2" v-else />
													</b-td>
												</b-tr>
											</b-table-simple>
										</b-tab>
										<b-tab>
											<template v-slot:title>
												Mecánica
											</template>
											<b-alert show variant="faded" class="my-4 bg-grey">
												<b-table-simple borderless small>
													<b-tr>
														<b-th><small><b>Leyenda:</b></small></b-th>
														<b-td>
															<font-awesome-icon :icon="['fas', 'check-circle']" size="lg" class="text-success mr-2" />
															<small>Auto con pieza en buen estado.</small>
														</b-td>
														<b-td>
															<font-awesome-icon :icon="['fas', 'exclamation-circle']" size="lg" class="text-warning mr-2" />
															<small>Auto con pieza en estado regular o malo.</small>
														</b-td>
													</b-tr>
												</b-table-simple>
											</b-alert>
											<b-table-simple fixed borderless class="text-center">
												<b-tr>
													<b-td><b class="bg-macal text-white p-2 border-radius">Suspensión</b></b-td>
													<b-td><b class="bg-macal text-white p-2 border-radius">Frenos</b></b-td>
													<b-td><b class="bg-macal text-white p-2 border-radius">Bajo el capó</b></b-td>
													<b-td><b class="bg-macal text-white p-2 border-radius">Ruedas</b></b-td>
													<b-td><b class="bg-macal text-white p-2 border-radius">Otros</b></b-td>
												</b-tr>
												<b-tr>
													<b-td>
														<b-table-simple small borderless v-for="(element, key) in car_state.suspension" :key="key">
															<b-tr v-b-tooltip.hover :title="element.tooltip">
																<b-td width="1%">
																	<font-awesome-icon :icon="['fas', 'check-circle']" size="lg" class="text-success mr-2" v-if="element.value" />
																	<font-awesome-icon :icon="['fas', 'exclamation-circle']" size="lg" class="text-warning mr-2" v-else />
																</b-td>
																<b-td class="text-left">
																	<small>{{element.title}}</small>
																</b-td>
															</b-tr>
														</b-table-simple>
													</b-td>
													<b-td>
														<b-table-simple small borderless v-for="(element, key) in car_state.brakes" :key="key">
															<b-tr v-b-tooltip.hover :title="element.tooltip">
																<b-td width="1%">
																	<font-awesome-icon :icon="['fas', 'check-circle']" size="lg" class="text-success mr-2" v-if="element.value" />
																	<font-awesome-icon :icon="['fas', 'exclamation-circle']" size="lg" class="text-warning mr-2" v-else />
																</b-td>
																<b-td class="text-left">
																	<small>{{element.title}}</small>
																</b-td>
															</b-tr>
														</b-table-simple>
													</b-td>
													<b-td>
														<b-table-simple small borderless v-for="(element, key) in car_state.underhood" :key="key">
															<b-tr v-b-tooltip.hover :title="element.tooltip">
																<b-td width="1%">
																	<font-awesome-icon :icon="['fas', 'check-circle']" size="lg" class="text-success mr-2" v-if="element.value" />
																	<font-awesome-icon :icon="['fas', 'exclamation-circle']" size="lg" class="text-warning mr-2" v-else />
																</b-td>
																<b-td class="text-left">
																	<small>{{element.title}}</small>
																</b-td>
															</b-tr>
														</b-table-simple>
													</b-td>
													<b-td>
														<b-table-simple small borderless v-for="(element, key) in car_state.wheels" :key="key">
															<b-tr v-b-tooltip.hover :title="element.tooltip">
																<b-td width="1%">
																	<font-awesome-icon :icon="['fas', 'check-circle']" size="lg" class="text-success mr-2" v-if="element.value" />
																	<font-awesome-icon :icon="['fas', 'exclamation-circle']" size="lg" class="text-warning mr-2" v-else />
																</b-td>
																<b-td class="text-left">
																	<small>{{element.title}}</small>
																</b-td>
															</b-tr>
														</b-table-simple>
													</b-td>
													<b-td>
														<b-table-simple small borderless v-for="(element, key) in car_state.others" :key="key">
															<b-tr v-b-tooltip.hover :title="element.tooltip">
																<b-td width="1%">
																	<font-awesome-icon :icon="['fas', 'check-circle']" size="lg" class="text-success mr-2" v-if="element.value" />
																	<font-awesome-icon :icon="['fas', 'exclamation-circle']" size="lg" class="text-warning mr-2" v-else />
																</b-td>
																<b-td class="text-left">
																	<small>{{element.title}}</small>
																</b-td>
															</b-tr>
														</b-table-simple>
													</b-td>
												</b-tr>
											</b-table-simple>
										</b-tab>
										<b-tab>
											<template v-slot:title>
												Alertas, Niveles y Fugas
											</template>
											<b-alert show variant="faded" class="my-4 bg-grey">
												<b-table-simple borderless small>
													<b-tr>
														<b-th><small><b>Leyenda:</b></small></b-th>
														<b-td>
															<font-awesome-icon :icon="['fas', 'check-circle']" size="lg" class="text-success mr-2" />
															<small>Auto sin alertas ni fugas y líquidos en nivel.</small>
														</b-td>
														<b-td>
															<font-awesome-icon :icon="['fas', 'exclamation-circle']" size="lg" class="text-warning mr-2" />
															<small>Auto con alertas, fugas y/o falta de líquidos.</small>
														</b-td>
													</b-tr>
												</b-table-simple>
											</b-alert>
											<b-table-simple fixed borderless class="text-center">
												<b-tr>
													<b-td><b class="bg-macal text-white p-2 border-radius">Alertas</b></b-td>
													<b-td><b class="bg-macal text-white p-2 border-radius">Niveles</b></b-td>
													<b-td><b class="bg-macal text-white p-2 border-radius">Fugas</b></b-td>
												</b-tr>
												<b-tr>
													<b-td>
														<b-table-simple small borderless v-for="(element, key) in car_state.alert" :key="key">
															<b-tr v-b-tooltip.hover :title="element.tooltip">
																<b-td width="1%">
																	<font-awesome-icon :icon="['fas', 'check-circle']" size="lg" class="text-success mr-2" v-if="element.value" />
																	<font-awesome-icon :icon="['fas', 'exclamation-circle']" size="lg" class="text-warning mr-2" v-else />
																</b-td>
																<b-td class="text-left">
																	<small>{{element.title}}</small>
																</b-td>
															</b-tr>
														</b-table-simple>
													</b-td>
													<b-td>
														<b-table-simple small borderless v-for="(element, key) in car_state.level" :key="key">
															<b-tr v-b-tooltip.hover :title="element.tooltip">
																<b-td width="1%">
																	<font-awesome-icon :icon="['fas', 'check-circle']" size="lg" class="text-success mr-2" v-if="element.value" />
																	<font-awesome-icon :icon="['fas', 'exclamation-circle']" size="lg" class="text-warning mr-2" v-else />
																</b-td>
																<b-td class="text-left">
																	<small>{{element.title}}</small>
																</b-td>
															</b-tr>
														</b-table-simple>
													</b-td>
													<b-td>
														<b-table-simple small borderless v-for="(element, key) in car_state.leakage" :key="key">
															<b-tr v-b-tooltip.hover :title="element.tooltip">
																<b-td width="1%">
																	<font-awesome-icon :icon="['fas', 'check-circle']" size="lg" class="text-success mr-2" v-if="element.value" />
																	<font-awesome-icon :icon="['fas', 'exclamation-circle']" size="lg" class="text-warning mr-2" v-else />
																</b-td>
																<b-td class="text-left">
																	<small>{{element.title}}</small>
																</b-td>
															</b-tr>
														</b-table-simple>
													</b-td>
												</b-tr>
											</b-table-simple>
										</b-tab>
									</b-tabs>
								</b-tab>
								<b-tab v-if="car.detail_photos">
									<template v-slot:title>
										<p class="section-subheader text-left">
											<font-awesome-icon :icon="['fal', 'camera']" />
											Detalles ({{car.detail_photos.length}})
										</p>
									</template>
									<p class="mt-3 text-justify">
										<b-carousel id="car-slide" class="car-slide" indicators controls :interval="0">
											<b-carousel-slide v-for="(image, index) in car.detail_photos" :key="index" :img-src="image.url"></b-carousel-slide>
										</b-carousel>
									</p>
								</b-tab>
							</b-tabs>
							<b-row v-else>
								<b-col v-if="car.grade_detail !== null">
									<h2 class="text-center"><b>¡Participa Informado!</b></h2>
									<h3 class="my-4 text-center"> +85 puntos de revisión validados por <b-img src="images/detail/logo-fullmec.png" class="d-inline-block" height="70px" ></b-img></h3>
									<h3 class="text-center"> Conoce la inspección general de este auto</h3>
									<div class="h2 my-5 text-center">
										<div class="bg-macal d-inline-block text-white p-2 border-radius"><b>En Desarrollo</b></div>
									</div>
								</b-col>
							</b-row>
						</b-col>
					</b-row>
					<b-row>
						<b-col  class="text-center" v-if="car.inspection_grade && car.grade_detail !== null">
							<b-button variant="outline-macal" :href="inspection_url"><font-awesome-icon :icon="['fal', 'download']" class="mr-3" />Descargar Inspección General Aquí</b-button>
						</b-col>
					</b-row>
				</b-col>
			</v-section-white>
			<v-section-white v-if="car.inspection_grade && car.grade_detail !== null" class="mt-4 d-lg-none">
				<h3 class="text-center">Inspección General</h3>
				<b-row>
					<b-col>
						<h4 class="text-center"><b>¡Participa Informado!</b></h4>
						<h5 class="my-4 text-center"> +85 puntos de revisión validados por <b-img src="images/detail/logo-fullmec.png" class="d-inline-block" height="50px" ></b-img></h5>
						<h5 class="text-center"> Conoce la inspección general de este auto</h5>
						<div class="h4 my-3 text-center">
							<div class="bg-macal d-inline-block text-white p-2 py-4 border-radius"><b>{{car.inspection_grade.replace(".",",")}} puntos</b></div>
						</div>
					</b-col>
				</b-row>
				<b-row>
					<b-col class="text-center">
						<b-button variant="outline-macal" :href="inspection_url"><font-awesome-icon :icon="['fal', 'download']" class="mr-3" />Descargar Inspección General Aquí
						</b-button>
					</b-col>
				</b-row>
			</v-section-white>
			<v-section-white v-else class="mt-4 d-lg-none">
				<h3 v-if="car.grade_detail !== null" class="text-center">Inspección General</h3>
				<b-row v-if="car.grade_detail !== null">
					<b-col>
						<h4 class="text-center"><b>¡Participa Informado!</b></h4>
						<h5 class="my-4 text-center"> +85 puntos de revisión validados por <b-img src="images/detail/logo-fullmec.png" class="d-inline-block" height="50px" ></b-img></h5>
						<h5 class="text-center"> Conoce la inspección general de este auto</h5>
						<div class="h4 my-3 text-center">
							<div class="bg-macal d-inline-block text-white p-2 py-4 border-radius"><b>Próximamente</b></div>
						</div>
					</b-col>
				</b-row>
			</v-section-white>
			<v-section-grey class="text-center d-none d-lg-block">
				<b-row :class="['mt-5']">
					<b-col md="12">
						<h2 class="text-center d-none d-lg-block"><b>SERVICIOS PARA TI</b></h2>
						<h5 class="text-center mb-4 d-none d-lg-block">La compra inteligente esta aquí</h5>
						<h4 class="text-center d-lg-none bold"><b>SERVICIOS PARA TI</b></h4>
						<p class="text-center mb-4 d-lg-none">La compra inteligente esta aquí</p>
						<b-tabs nav-wrapper-class="col-md-3 pr-0" content-class="" class="macal-financing-tabs car-general-tabs mt-5" vertical >
							<v-tab-financing :price="car.price" :simulation="simulation"></v-tab-financing>
							<v-tab-transfer :car_id="car_id" ></v-tab-transfer>
							<v-tab-warranty></v-tab-warranty>
							<v-tab-tag></v-tab-tag>
						</b-tabs>
					</b-col>
				</b-row>
			</v-section-grey>
			<div class="text-center d-lg-none mt-5">
				<div role="tablist">
					<v-tab-financing-mobile :price="car.price" :simulation="simulation"></v-tab-financing-mobile>
					<v-tab-transfer-mobile :car_id="car_id" ></v-tab-transfer-mobile>
					<v-tab-warranty-mobile></v-tab-warranty-mobile>
					<v-tab-tag-mobile></v-tab-tag-mobile>
				</div>
			</div>
			<v-section-white class="mt-5">
				<h2 class="text-center mb-4">¡Más servicios para ti!</h2>
				<b-row>
					<b-col md="4" offset-md="2">
						<div class="text-center bg-grey py-5 shadow-sm">
							<h4 class="mt-5"><b class="underline-mac">¿No encuentras el auto que buscas?</b></h4>
							<h3 class="text-macal">&nbsp;</h3>
							<b-button size="lg" class=" mt-5 pl-5 pr-5" variant="macal" href="https://www.macal.cl/Form/AvisenVehiculos">Encarga tu próximo auto aquí</b-button>
						</div>
					</b-col>
					<b-col md="4">
						<div class="text-center bg-grey py-5 shadow-sm">
						<h4 class="mt-5"><b class="underline-macal">¡Nos interesa tu auto!</b>
						<br/>
						<b class="text-macal">MACAL TE PAGA MÁS</b></h4>
						<b-button size="lg" class=" mt-5 pl-5 pr-5" variant="macal" :to="{ name: 'vehicles-sell', query: { utm_source: 'macal_internos', utm_medium: 'vende_ficha_internos', utm_content: 'vende_auto', utm_campaign: 'marketing_medios_internos'}}">VENDE ACÁ TU AUTO</b-button>
						</div>
					</b-col>
				</b-row>
			</v-section-white>
			<v-section-grey class="mt-5"  v-if="true == false">
                <b-col md="10" offset-md="1">
                    <h2 class="text-center mb-4">Recomendados para ti</h2>
                    <b-card-group deck class="card-cars">
                        <v-car-card  v-for="(car, index) in recomendations" :key="index" :car="car"></v-car-card>
                    </b-card-group>
                </b-col>
            </v-section-grey>
		</b-container>
	</div>
</div>
</template>
<script>
	import SectionWhite from "../../components/section-white";
	import SectionGrey from "../../components/section-grey";
	import CarCard from "../../components/car-card";
	import AuctionDetail from "./components/auction-detail";
	import TabFinancing from "./components/tab-financing-iframe";
	import TabWarranty from "./components/tab-warranty";
	import TabTag from "./components/tab-tag";
	import TabTransfer from "./components/tab-transfer";
	import TabFinancingMobile from "./components/tab-financing-iframe-mobile";
	import TabWarrantyMobile from "./components/tab-warranty-mobile";
	import TabTagMobile from "./components/tab-tag-mobile";
	import TabTransferMobile from "./components/tab-transfer-mobile";

	import CarLoading from "./components/car/car-detail-loading";
	import Rss from "./components/rss";

  export default {
	name: 'Detail',
	components: {
		'v-section-white': SectionWhite,
		'v-section-grey': SectionGrey,
		'v-car-card': CarCard,
		'v-auction-detail': AuctionDetail,
		'v-tab-financing': TabFinancing,
		'v-tab-warranty': TabWarranty,
		'v-tab-tag': TabTag,
		'v-tab-transfer': TabTransfer,
		'v-tab-financing-mobile': TabFinancingMobile,
		'v-tab-warranty-mobile': TabWarrantyMobile,
		'v-tab-tag-mobile': TabTagMobile,
		'v-tab-transfer-mobile': TabTransferMobile,

		'v-rss': Rss,
		CarLoading,
	},
	props:{
		car_id: {default: null }
	},
	data() {
		return {
			is_favourite: false,
			car: {
				photos: [],
				detail_photos: [],
				general: [],
				inspection_grade: null,
				visual_grade: null,
				documentations: [],
				cav_url: "",
				inspection: {specs: {}, bodywork: {} },
				grade_detail: {}
			},
			simulation: {
				cae: "",
				total: "",
				amount: "",
				due: "",
				credit: "",
				foot: "",
				loading: true
			},
			equipment:{
				security: [],
				confort: [],
				multimedia: [],
				exterior: []
			},
			bodywork:{
				scratch: [],
				dent: []
			},
			car_state:{
				suspension: [],
				brakes: [],
				underhood: [],
				wheels: [],
				others: [],
				alert: [],
				level: [],
				leakage: []
			},
			due: "60",
			inspection_url: process.env.VUE_APP_BASE_URL+"cars/"+this.car_id+"/inspection",
			visual_inspection_url: process.env.VUE_APP_BASE_URL+"cars/"+this.car_id+"/visual_inspection",
			recomendations: [],
			parsedPrice: "",
			is_liquidation: false,
			favourite_url: window.location.href,
			isDisabled: true
		}
	},
	beforeMount(){
		const self = this;
		if(this.$store.state.isLogged){
			this.axios.post(process.env.VUE_APP_BASE_URL+'users/favorites', { cookie: this.$cookies.get("MCart") } ).then(res => {
				self.$store.commit('set_favorites', res.data.cars_id)
				self.$forceUpdate();
				self.is_favourite = self.$store.state.favorites.includes(parseInt(this.car_id))
			});
		}
	},
	mounted() {
		//this.$zendesk.show()
	},
	beforeDestroy(){
		//this.$zendesk.hide()
	},
	methods: {
		social_counter(id){
			this.axios.post("meters/social", {dvl_storage_id: this.car.operational_id, social_media_type_id: id}).then(() => {})
		},
		send_count(){
			this.axios.post("meters", {id: this.car.operational_id, url: window.location.href, width: window.innerWidth, height: window.innerHeight}).then(() => {})
		},
		onOpen() {
			this.$refs.tooltip.$emit('open')
		},
		onClose() {
			this.$refs.tooltip.$emit('close')
		},
		recomended(){
			let self = this
			if(this.$store.state.isLogged){
				this.axios.get("users/recommended", {params: {id: this.car_id}}).then(result => {
					self.recomendations = result.data
				})
				.catch(() => {
					//this.$store.commit('hideLoading');
				})
			}
		},
		calculate_finantial(){
			let foots_mounts= [1000000,2000000,3000000,4000000,5000000,6000000,7000000,8000000,9000000,10000000,12000000,14000000,16000000,18000000,20000000,25000000,30000000]
			let percentage = this.car.price * 0.4
			let result = foots_mounts.reduce(function(prev, curr) {
				return (Math.abs(curr - percentage) < Math.abs(prev - percentage) ? curr : prev);
			});
			this.axios.post("financings/simulation", {amount: this.car.price, due: this.due, foot: result}).then(result => {
				this.simulation = result.data;
				this.simulation.credit = this.car.price.toString().replace(/\./g, "").replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
				this.simulation.loading = false
			}).catch(() => {
			})
		},
		showCar(){
			let self = this
			this.axios.get("cars/"+this.car_id).then(result => {
				self.car = result.data;
				self.parsedPrice = new Intl.NumberFormat("es-CL").format(parseInt(self.car.price));
				self.is_favourite = self.$store.state.favorites.includes(parseInt(self.car_id))
				self.is_liquidation = self.car.business_line.toUpperCase() == "LIQUIDACIONES"
				self.equipment.security = self.car.inspection.specs.find(x => x.icon === "security").data;
				self.equipment.confort = self.car.inspection.specs.find(x => x.icon === "confort").data;
				self.equipment.multimedia = self.car.inspection.specs.find(x => x.icon === "multimedia").data;
				self.equipment.exterior = self.car.inspection.specs.find(x => x.icon === "exterior").data;
				self.bodywork.scratch = self.car.inspection.bodywork.find(x => x.icon === "scratch").data;
				self.bodywork.dent = self.car.inspection.bodywork.find(x => x.icon === "dent").data;
				self.car_state.suspension = self.car.inspection.car_state.find(x => x.icon === "suspension").data;
				self.car_state.brakes = self.car.inspection.car_state.find(x => x.icon === "brakes").data;
				self.car_state.underhood = self.car.inspection.car_state.find(x => x.icon === "underhood").data;
				self.car_state.wheels = self.car.inspection.car_state.find(x => x.icon === "wheels").data;
				self.car_state.others = self.car.inspection.car_state.find(x => x.icon === "others").data;
				self.car_state.alert = self.car.inspection.car_state.find(x => x.icon === "alert").data;
				self.car_state.level = self.car.inspection.car_state.find(x => x.icon === "level").data;
				self.car_state.leakage = self.car.inspection.car_state.find(x => x.icon === "leakage").data;
				//this.calculate_finantial();
				this.send_count()
			}).catch(() => {
				//this.$store.commit('hideLoading');
			})
	},
      scrollFromHead() {
		window.scroll({
			top: document.querySelector('.scroll-receiver').offsetTop - 150,
			behavior: 'smooth'
		});
	//	document.querySelector('.scroll-receiver').scrollIntoView({
	//		behavior: 'smooth'
	//	});
	},
	add_favorite(){
			const cur = this;
			if(this.$store.state.isLogged){
				cur.is_favourite = true;
				cur.$store.commit('add_favorite', cur.car.id)
				this.axios.post("users/favorite", {operational_id: this.car.operational_id, cookie: this.$cookies.get("MCart")}).then(result => {
					if(result.data.response){
						cur.is_favourite = true;
						var key = Object.keys(result.data.cookie)[0]
						var value = result.data.cookie[key];
						var cookie_domain = process.env.NODE_ENV == "production" ? ".macal.cl" : null
						this.$cookies.set(key, value, result.data.max_session_cookie, null, cookie_domain);
						var link = "https://www.macal.cl/Carro/AbonoNuevaWebOnline?autocavid="+cur.car.operational_id;
						var el = document.getElementById('operational-favourite-link');
						el.value= link;
						el.dispatchEvent(new Event('input'));
						this.$bvToast.show('favourite-toast');
					}
				})
				.catch(() => {
				})
			}else{
				this.$store.commit('set_login_favorite', { operational_id: cur.car.operational_id, inner_id: cur.car.id });
				this.$bvModal.show('modal-login');
			}
		},
		remove_favorite(){
			const cur = this;
			cur.is_favourite = false;
			cur.$store.commit('remove_favorite', cur.car.id)
			this.axios.delete("users/unfavorite", {params: {operational_id: this.car.operational_id, cookie: this.$cookies.get("MCart")}}).then(result => {
				if(result.data.response){
					cur.is_favourite = false;
					var key = Object.keys(result.data.cookie)[0]
					var value = "";
					if(result.data.cookie[key] == null){
						value = "";
					}else{
						value = result.data.cookie[key];
					}
					var cookie_domain = process.env.NODE_ENV == "production" ? ".macal.cl" : null
					this.$cookies.set(key, value, result.data.max_session_cookie, null, cookie_domain);
				}
			})
			.catch(() => {
			})
		},
        copy(){
            var dummy = document.createElement('input'),
            text = window.location.href;
            document.body.appendChild(dummy);
            dummy.value = text;
            dummy.select();
            document.execCommand('copy');
            document.body.removeChild(dummy);
        }
	},
	watch: {
		car_id: {
			handler: function() {
				this.recomended()
				this.showCar()
				this.amount = this.car.price;
			},
			deep: true,
			immediate: true
		},
		'$store.state.favorites': {
			handler: function()  {
				if(this.$store.state.favorites){
					this.is_favourite = this.$store.state.favorites.includes(parseInt(this.car.id));
				}
			},
		deep: true,
		immediate: true
		}
	}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.car-detail{
		font-size: .9em;
	}
	.price{
		line-height: 1em;
		font-size: 2.8em;
	}
	.kms-text, .kms-text small{
		font-size: 70%;
		font-weight: 600;
	}
	.dues-data {
		font-size: 1.2rem;
		font-weight: 600;
	}
	@media (min-width: 991px){
		#specifications{
			margin-top: 100px;
		}
	}
	.p-0 {
		padding: 0
	}
	.favourite-car-slide{
		z-index: 100;
		position: absolute;
		right: 0;
		margin-right: 10px;
		cursor: pointer;
		opacity: .8;
		color: #EF6666;
		-webkit-transition: opacity .5s ease-in;
		-moz-transition: opacity .5s ease-in;
		-o-transition: opacity .5s ease-in;
		-ms-transition: opacity .5s ease-in;
		transition: opacity .5s ease-in;
		margin-top: 10px;
	}
	.favourite-car-slide:hover{
		opacity: 1;
	}
	.non{
		color: #ccc;
	}
	.link-liq:hover{
		text-decoration: none !important;
	}
</style>
